import React from 'react';

const RatnaBullet = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 12 19" fill="none">
      <circle cx="6" cy="10" r="6" fill="#C6B9FF" />
      <circle cx="6" cy="10" r="3" fill="#7357E9" />
    </svg>
  );
};

export default RatnaBullet;
